// Page/modal loading indicator. Same indigo ring used across the app.
// `label` shows underneath as a small uppercase caption; pass an empty string
// (or omit) for the spinner alone. `size` is "sm" | "md" | "lg".

const SIZE_CLASSES = {
  sm: "w-6 h-6 border-2",
  md: "w-10 h-10 border-[3px]",
  lg: "w-14 h-14 border-4",
};

export default function Spinner({ label = "", size = "md", className = "" }) {
  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  return (
    <div
      className={`flex flex-col items-center justify-center gap-4 ${className}`}
    >
      <div
        className={`${sizeClass} rounded-full border-slate-200 border-t-indigo-600 animate-spin`}
      />
      {label && (
        <span className="text-[10px] font-bold uppercase tracking-widest text-slate-500">
          {label}
        </span>
      )}
    </div>
  );
}
